import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ScommesseEsitoSkeleton } from 'components/scommesseEsitoSkeleton';
import { ScommesseTableTitle } from 'components/scommesseTable/scommesseTableTitle';
import { calculateBoxNumber, esitoTrKey } from 'components/scommesseTipo';
import { TooltipPosition } from 'components/tooltip';
import { useInfoTipo } from 'features/sport/hooks';
import { KeyManagerSport } from 'features/sport/utils/keyManager';
import useWindowSize from 'hooks/useWindowSize';
import { isTruthy } from 'utility/functions';
import { SportScommesseRenderConditionalProps } from 'features/sport/components/sportScommesseRenderConditional';
import { ConditionalContainer } from 'features/sport/components/sportScommesseRenderConditional/ConditionalContainer';
import styles from './SportScommesseRenderConditional.module.scss';

export const SportScommesseRenderSkeleton = (props: SportScommesseRenderConditionalProps) => {
  const {
    index,
    hasTitle,
    isEstesa,
    hasHeader,
    className,
    isAntepost,
    scommessaKey,
    isTooltipClicked,
    containerClassName,
    isManifestazioneTemplate,
    setIsTooltipClicked,
  } = props ?? {};

  const { isMobile } = useWindowSize();

  const km = useMemo(() => new KeyManagerSport(scommessaKey), [scommessaKey]);

  const infoTipoScommessa = useInfoTipo(km.tipoScommessaId);

  const boxes = calculateBoxNumber(infoTipoScommessa, esitoTrKey);

  if (isTruthy(boxes.length)) {
    return (
      <ConditionalContainer
        index={index}
        className={classNames(containerClassName, { [styles.full]: isEstesa })}
        scommessaKey={scommessaKey}
      >
        {hasTitle ? (
          <ScommesseTableTitle
            labelDx={infoTipoScommessa?.descrizione}
            labelDxTrKey={infoTipoScommessa?.descrizioneTrKey}
            className={classNames(styles.mainTitle, {
              [styles.removeTitle]: isManifestazioneTemplate,
              [styles.titleAntepost]: isAntepost,
            })}
            tooltipText={infoTipoScommessa?.toolTip}
            tooltipTextTrKey={infoTipoScommessa?.toolTipTrKey}
            tooltipPosition={isMobile || isEstesa ? TooltipPosition.BOTTOM_LEFT : TooltipPosition.BOTTOM}
            isEstesa={isEstesa}
            setIsTooltipClicked={setIsTooltipClicked}
            isTooltipClicked={isTooltipClicked}
          />
        ) : null}
        <div className={classNames(styles.wrapper, className)} suppressHydrationWarning>
          {boxes.map(({ header, headerTrKey, isInfoAgg, size }, index) => (
            <ScommesseEsitoSkeleton
              key={`${header}_${index}`}
              header={hasHeader ? header : undefined}
              headerTrKey={headerTrKey}
              size={isInfoAgg ? size : undefined}
              testId={headerTrKey}
            />
          ))}
        </div>
      </ConditionalContainer>
    );
  }

  return <React.Fragment key={scommessaKey} />;
};